import React, { useEffect, useContext, useState } from 'react';
import { ApiContext } from '../Contexts/ApiContext';
import MarkdownTextPresenter from '../Components/MarkdownTextPresenter';


const DeveloperPage = () => {

    const [summaryPrompt, setSummaryPrompt] = React.useState(null);
    const [caseNotesPrompt, setCaseNotesPrompt] = React.useState(null);
    const [transcriptionPostProcessingPrompt, setTranscriptionPostProcessingPrompt] = React.useState(null);
    const [testData, setTestData] = React.useState(null);
    const [testResult, setTestResult] = React.useState(null);

    const { 
        getPromptCongigAsync, 
        upsertPromptCongigAsync, 
        testSummaryPromptAsync,
        testCaseNotesPromptAsync,
        testTranscriptionPostProcessingAsync
    } = useContext(ApiContext);

    const [isPublishing, setIsPublishing] = useState(false);
    const [isTesting, setIsTesting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        handleInit();
    }, []);

    const handleInit = async () => {
        console.log("handleInit DeveloperPage");
        setIsLoading(true);
        try {
            const {summaryPrompt, caseNotesPrompt, transcriptionPrompt} = await getPromptCongigAsync();
            setSummaryPrompt(summaryPrompt);
            setCaseNotesPrompt(caseNotesPrompt);
            setTranscriptionPostProcessingPrompt(transcriptionPrompt);
        } finally {
            setIsLoading(false);
        }
    }

    const handlePublish = async () => {
        setIsPublishing(true);
        try {
            console.log("Publishing summary prompt:", summaryPrompt);
            await upsertPromptCongigAsync(summaryPrompt, caseNotesPrompt, transcriptionPostProcessingPrompt);
        } finally {
            setIsPublishing(false);
        }
    }

    const handleTestSummary = async () => {
        setIsTesting(true);
        try {
            const result = await testSummaryPromptAsync(testData, summaryPrompt);
            setTestResult(result);
        } finally {
            setIsTesting(false);
        }
    }

    const handleTestCaseNotes = async () => {
        setIsTesting(true);
        try {
            const result = await testCaseNotesPromptAsync(testData, caseNotesPrompt);
            setTestResult(result);
        } finally {
            setIsTesting(false);
        }
    }

    const handleTestTranscriptionPostProcessing = async () => {
        setIsTesting(true);
        try {
            const result = await testTranscriptionPostProcessingAsync(testData, transcriptionPostProcessingPrompt);
            setTestResult(result);
        } finally {
            setIsTesting(false);
        }
    }

    return (
        <div className="p-4 overflow-y-auto h-full">
            <h2 className="text-xl font-semibold mb-4">Developer Configuration</h2>

            {/* Testing Panel - Top */}
            <section className="bg-white border border-gray-300 rounded-md p-6 mb-6">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-semibold text-slate-800">
                        Testing Environment
                    </h2>
                    <div className="flex space-x-4">
                        <button 
                            onClick={handleTestSummary}
                            disabled={isTesting}
                            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded
                                     active:scale-[0.98] transition duration-200
                                     disabled:opacity-50 disabled:cursor-not-allowed
                                     flex items-center justify-center"
                        >
                            {isTesting ? (
                                <>
                                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Testing...
                                </>
                            ) : 'Test GP Letter'}
                        </button>
                        <button 
                            onClick={handleTestCaseNotes}
                            disabled={isTesting}
                            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded
                                     active:scale-[0.98] transition duration-200
                                     disabled:opacity-50 disabled:cursor-not-allowed
                                     flex items-center justify-center"
                        >
                            {isTesting ? (
                                <>
                                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Testing...
                                </>
                            ) : 'Test Case Notes'}
                        </button>

                        <button 
                            onClick={handleTestTranscriptionPostProcessing}
                            disabled={isTesting}
                            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded
                                     active:scale-[0.98] transition duration-200
                                     disabled:opacity-50 disabled:cursor-not-allowed
                                     flex items-center justify-center"
                        >
                            {isTesting ? (
                                <>
                                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                    </svg>
                                    Testing...
                                </>
                            ) : 'Test Transcription Post-processing'}
                        </button>
                    </div>
                </div>
                
                <div className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                            Test Data
                        </label>
                        <textarea 
                            placeholder="Enter test data here..." 
                            className="w-full h-48 p-3 bg-white border border-gray-300 rounded-md 
                                     text-slate-700 placeholder-slate-400
                                     focus:outline-none focus:ring-2 focus:ring-blue-500/40 
                                     transition duration-200"
                            value={testData || ''}
                            onChange={(e) => setTestData(e.target.value)}
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                            Test Results
                        </label>
                        <MarkdownTextPresenter markdown={testResult} />
                        
                    </div>
                </div>
            </section>

            {/* Prompts Panel - Bottom */}
            <section className="bg-white border border-gray-300 rounded-md p-6">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-semibold text-slate-800">
                        Prompts Configuration
                    </h2>
                    {isLoading && (
                        <div className="flex items-center text-slate-600">
                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Loading prompts...
                        </div>
                    )}
                </div>
                
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                            GP Letter Prompt
                        </label>
                        <textarea 
                            placeholder="Enter your gp letter prompt here..." 
                            className="w-full h-48 p-3 bg-white border border-gray-300 rounded-md 
                                     text-slate-700 placeholder-slate-400
                                     focus:outline-none focus:ring-2 focus:ring-blue-500/40 
                                     transition duration-200"
                            value={summaryPrompt || ''}
                            onChange={(e) => setSummaryPrompt(e.target.value)}
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                            Case Notes Prompt
                        </label>
                        <textarea 
                            placeholder="Enter your case notes prompt here..." 
                            className="w-full h-48 p-3 bg-white border border-gray-300 rounded-md 
                                     text-slate-700 placeholder-slate-400
                                     focus:outline-none focus:ring-2 focus:ring-blue-500/40 
                                     transition duration-200"
                            value={caseNotesPrompt || ''}
                            onChange={(e) => setCaseNotesPrompt(e.target.value)}
                        />
                    </div>
                </div>


                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                            Transcription post-processing prompt
                        </label>
                        <textarea 
                            placeholder="Enter transcription post-processing prompt here..." 
                            className="w-full h-48 p-3 bg-white border border-gray-300 rounded-md 
                                     text-slate-700 placeholder-slate-400
                                     focus:outline-none focus:ring-2 focus:ring-blue-500/40 
                                     transition duration-200"
                            value={transcriptionPostProcessingPrompt || ''}
                            onChange={(e) => setTranscriptionPostProcessingPrompt(e.target.value)}
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                            Reserved space 
                        </label>
                        <textarea 
                            placeholder="Reserved space for prompt here..." 
                            disabled
                            className="w-full h-48 p-3 bg-white border border-gray-300 rounded-md 
                                     text-slate-700 placeholder-slate-400
                                     focus:outline-none focus:ring-2 focus:ring-blue-500/40 
                                     transition duration-200"
                        />
                    </div>
                </div>

                <button 
                    className="w-full mt-6 bg-blue-500 text-white px-6 py-2 rounded
                             hover:bg-blue-600 active:scale-[0.98] transition duration-200
                             disabled:opacity-50 disabled:cursor-not-allowed
                             flex items-center justify-center" 
                    onClick={handlePublish}
                    disabled={isPublishing}
                >
                    {isPublishing ? (
                        <>
                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Publishing...
                        </>
                    ) : 'Publish Prompts'}
                </button>
            </section>
        </div>
    );
};


const handleInit = async () => {

};

export default DeveloperPage;